import RoleSelector from '@/components/selectors/RoleSelector';
import DashboardSelectorStyles from './DashboardSelectorStyles';

const DashboardRoleSelector = (props) => (
  <DashboardSelectorStyles>
    <RoleSelector {...props} />
  </DashboardSelectorStyles>
);

export default DashboardRoleSelector;
